var $aec04d91afeec604$exports = {};
$aec04d91afeec604$exports = {
    "info": `Informace`,
    "negative": `Chyba`,
    "positive": `\xdasp\u{11B}ch`
};


export {$aec04d91afeec604$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
